// extracted by mini-css-extract-plugin
export default {"address":"reportProposedSale_address__ZsCja","modalbody":"reportProposedSale_modalbody__QmZIC"};